export function getLocalData(key) {
    if (!localStorage) {
        return;
    }
    try {
        const data = localStorage.getItem(key);
        if (data) {
            return JSON.parse(data);
        }
    }
    catch {
        console.warn(`Local storage item ${key} contains invalid json.`);
    }
    return undefined;
}
export function setLocalData(key, data) {
    if (!localStorage) {
        return;
    }
    localStorage.setItem(key, JSON.stringify(data));
}
